<template>
    <div class="h-48 w-full rounded animated-background" />
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}
.animated-background {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: linear-gradient(
        to right,
        config("theme.colors.grey-lighter") 8%,
        config("theme.colors.grey-lightest") 18%,
        config("theme.colors.grey-lighter") 33%
    );
    background-size: 800px 100px;
    position: relative;
}
</style>
